import React from 'react'

// Types
import { NavigationProps, NavigationState, Routes } from '../types'

// Context
import NavigationContext, { initialState } from './NavigationContext'

export default (
  navigationState: {[prop: string]: any}
) => (
  WrappedComponent: React.ComponentType
): any => class NavigationContainer extends React.Component<NavigationProps> {

  state: NavigationState = {...initialState, ...navigationState}

  constructor(props: NavigationProps) {
    super(props)

    this.state.actions = {
      navigate: this.navigate,
      back: this.back,
      forward: this.forward,
    }
  }

  navigate = (route: string) => {
    let { index, history } = this.state
    if(index >= history.length) return

    if(route !== history[index]) {
      history.push(route)
      ++index
    }

    this.setState({ index })
  }

  back = () => {
    let { index } = this.state
    if(index < 1) return

    --index
    this.setState({ index })
  }

  forward = () => {
    let { index, history } = this.state
    if(index >= history.length) return

    ++index
    this.setState({ index })
  }

  render() {
    return (
      <NavigationContext.Provider value={this.state}>
        <WrappedComponent {...this.props} />
      </NavigationContext.Provider>
    )
  }

}
